import axios from "axios";
import { useEffect, useRef, useState,useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import BotResponse from "./ChatFolder/BotResponse";
import "./ChatFolder/Chat.css";
import "./Reactaudio.css";
import UserUtterance from "./ChatFolder/UserUtterance";
import AudioPlayerWidget from "./AudioPLayerWidget";
import moment from "moment";
import { MyContext } from "../context/ContextProvider";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "devextreme-react";
import {SetSelectedWorkdeskConversation,UpdateConversationLog} from "../../redux-store/actions";

const ChatDetails = ({ conversationData, showDialogCodes, setConversationData }) => {
  const { user } = useAuth0();
  const state = useSelector((state) => state);
  let selectedConversationId = state.SelectedConversationId;
  const {ConversationDate } = useContext(MyContext);
  let user_profile=user?.oi_profile?.toLowerCase() 
  const [conversation_date,setConversationDate]=ConversationDate
  let date=null;
  const dispatch=useDispatch()
  const messagesEndRef = useRef(null);
  
  const showConvesation = () => {
    if(conversationData.length!=0)
    {
      date=moment(conversationData[0].creation_date).format("YYYY-MM-DD")
      setConversationDate(date);

    }
     return conversationData.map((item,index) => { 
      let internal_timer_event= user?.oi_profile?.toLowerCase() == "demo" && item?.utterance=="state_internal_timer_fired" 

      let prevCodesStr ; 
      if (index > 0 && user_profile=="demo") { 
        prevCodesStr = conversationData?.[index - 1]?.system_response_code; 
        if (prevCodesStr) { 
          let prevCodes; 
          try { 
            prevCodes = JSON.parse(prevCodesStr.replace(/'/g, '"')); 
           } catch (e) { 
            prevCodes = [];
           } 
           
      if (prevCodes.some(code => ["img_demographics.dm.first_name", "img_demographics.dm.last_name", "img_demographics.dm.dob"].includes(code))) { 
        item.utterance = "*****"; 
        item.asr_corrected_text = "*****"; 
        item.original_text = "*****"; } 
      }else{ } 
    }
      
      if (item.utterance_from === "USER" || item.utterance_from === "ASR-2") {
        return  item.utterance && !internal_timer_event && <UserUtterance key={Math.random()} data={item}  showDialogCodes={showDialogCodes} conversationData={conversationData}></UserUtterance>;
      }
      if (item.utterance_from === "BOT") {
        return item.utterance && <BotResponse key={Math.random()} data={item} showDialogCodes={showDialogCodes}></BotResponse>;
      }
      return;
    });
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
 
    scrollToBottom();
  }, [conversationData]);
  

  return (
    <div className="chatdetails">
      <div style={{ flex: "1", overflowY: "scroll" }} className="chat">
        <div>{selectedConversationId != null && showConvesation()}</div>
        <div ref={messagesEndRef}></div>

        {selectedConversationId == null && (
          <div
            style={{
              marginTop: "5rem",
              textAlign: "center",
            }}
          >
            <h2>Please select a conversation</h2>
          </div>
        )}
      </div>
     <div>

     </div>
   {(user?.oi_profile?.toLowerCase() !== "customer" || user?.can_listen_to_audio===true) && user?.oi_profile?.toLowerCase() !== "demo"  && <AudioPlayerWidget date={date}/>} 
<div style={{ display: "flex", justifyContent: "center" }}>
  <Button
    text="Start Again"
    type="success"           
    stylingMode="contained"  
    onClick={() => { 
      setConversationData([]);
      dispatch(UpdateConversationLog([]))
      dispatch(SetSelectedWorkdeskConversation({conversation_id: null}))
    }}
    style={{
      maxWidth: "140px",     
      width: "100%",         
      fontSize: "14px",      
      padding: "5px 10px",   
      margin: "10px 0",
      display:user_profile === "demo" ?"flex":"none"
    }}
  />
</div>
    </div>
  );
};


export default ChatDetails;
